import React from 'react'
import './Button.css'
import Button, { ButtonProps } from 'react-bootstrap/Button'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Spinner } from 'react-bootstrap'

type KycButtonProps = {
  isLoading?: boolean
  onClick?: () => void
  className?: string
} & ButtonProps

const KycButton: React.FC<KycButtonProps> = ({
  variant,
  isLoading,
  onClick,
  className,
  children,
  ...rest
}) => {
  const buttonClass = `button ${
    variant === 'outline-primary' ? 'inverse' : ''
  } ${className}`.trim()

  return (
    <Button
      variant={variant}
      className={`button ${
        variant === 'outline-primary' ? 'inverse' : null
      } ${className}`}
      onClick={onClick}
      {...rest}
      style={{ boxShadow: 'none', border: '1px solid' }}
    >
      {isLoading && (
        <Spinner
          as="span"
          size="sm"
          animation="border"
          variant="dark"
          role="status"
          aria-hidden="true"
        />
      )}{' '}
      {children}
    </Button>
  )
}

export default KycButton
